import { type PropsWithChildren, useState } from 'react';

import { ChevronDown, ChevronUp } from 'lucide-react';

import { Button } from '@/components/shadcn/button';

type Props = PropsWithChildren<{
  title: string;
}>;

export default function RiskObjectGroup({ title, children }: Props) {
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => setIsOpen((isOpen) => !isOpen);

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border bg-neutral-100 p-2 dark:bg-neutral-900">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase">{title}</p>

        <Button onClick={handleToggle} variant="ghost" size="icon-xs">
          {isOpen && <ChevronUp className="size-4" />}
          {!isOpen && <ChevronDown className="size-4" />}
        </Button>
      </div>

      {isOpen && (
        <div className="grid w-full grid-cols-2 gap-4">{children}</div>
      )}
    </div>
  );
}
